import React from 'react';
import { X } from 'lucide-react';

interface QuickTramiteModalProps {
  isOpen: boolean;
  onClose: () => void;
  tramites: any[];
  onSelectTramite: (path: string) => void;
}

const QuickTramiteModal: React.FC<QuickTramiteModalProps> = ({ 
  isOpen, 
  onClose, 
  tramites, 
  onSelectTramite 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-900">Seleccionar Trámite</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <p className="text-gray-600 mb-6">
          Selecciona el tipo de trámite que deseas realizar:
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {tramites.map((tramite) => (
            <div 
              key={tramite.id}
              className="border border-gray-200 rounded-lg p-4 hover:border-primary-500 hover:shadow-md transition-all cursor-pointer"
              onClick={() => {
                onSelectTramite(tramite.path);
                onClose();
              }}
            >
              <div className="flex items-start space-x-3">
                <div className={`${tramite.color} p-2 rounded-lg`}>
                  <tramite.icon className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 mb-1">{tramite.title}</h3>
                  <p className="text-sm text-gray-600">{tramite.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="flex justify-end mt-6">
          <button 
            onClick={onClose}
            className="btn btn-secondary"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickTramiteModal;
